






















import { Vue, Component, Prop } from "vue-property-decorator";
import { bus } from "../../main";
import * as user from "../../_store/user.module";
import { NotaAzienda } from "@/_models/notaAzienda";

@Component
export default class EditNotaAzienda extends Vue {
    @Prop() info!: NotaAzienda;
    private nota: string;
    private notaRules: [boolean | string];

    constructor() {
        super();
        this.nota = this.info.nota;
        this.notaRules = [true];
    }

    validazioneNote() {
        var valid: boolean = false;
        if (this.nota === "") {
            this.notaRules = [true];
        } else {
            valid = /^[a-zA-Z0-9ìèéùòà,.'\x20]{2,}$/.test(this.nota);
            if (valid) {
                this.notaRules = [true];
            } else {
                this.notaRules = [
                    "Nota non deve contenere caratteri speciali"
                ];
            }
        }
    }

    close() {
        this.nota = this.info.nota;
        this.notaRules = [true];
        bus.$emit("closeEditDialog");
    }

    async executeTest() {
        this.validazioneNote();
    }

    save() {
        this.executeTest().then(() => {
            if ((this.$refs.form as Vue & { validate: () => boolean }).validate()) {
                var userInfo = user.readUserInfo(this["$store"]);
                var payload: NotaAzienda = {
                    idNota: this.info.idNota,
                    idAzienda: this.info.idAzienda,
                    idIstituto: this.info.idIstituto,
                    nota: this.nota,
                    dataCreazione: new Date().toISOString(),
                    idUtenteIstituto: userInfo.idUtente,
                    utenteIstituto: this.info.utenteIstituto
                };
                user.dispatchEditNotaAzienda(this["$store"], payload)
                .then(() => {
                    bus.$emit(
                        "successfullOperation",
                        "Nota modificata con successo"
                    );
                    this.close();
                    bus.$emit("loadNoteAzienda");
                })
                .catch(error => {
                    if (error.response.status === 403) {
                        bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
                        this["$router"].push("/login");
                    } else {
                        bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
                    }
                });
            }
        });
    }
}
